// Unique cover per course (uniId::courseName). Each cover is intentionally distinct.

const W = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const u = (id) => `https://images.unsplash.com/${id}${W}`;

// Explicit map: each key is `${uniId}::${courseName}`
const MAP = {
  // ───── PEGASO ─────
  "pegaso::Economia Aziendale (L-18)": u("photo-1454165804606-c3d57bc86b40"),
  "pegaso::Scienze Economiche (L-33)": u("photo-1611974789855-9c2a0a7236a3"),
  "pegaso::Ingegneria Civile e Ambientale (L-7)": u("photo-1503387762-592deb58ef4e"),
  "pegaso::Ingegneria Informatica (L-8)": u("photo-1517694712202-14dd9538aa97"),
  "pegaso::Scienze e Tecniche Psicologiche (L-24)": u("photo-1573497019940-1c28c88b4f3e"),
  "pegaso::Scienze del Turismo (L-15)": u("photo-1488646953014-85cb44e25828"),
  "pegaso::Scienze della Comunicazione (L-20)": u("photo-1542744173-8e7e53415bb0"),
  "pegaso::Giurisprudenza (LMG/01) · Ciclo Unico 5 anni": u("photo-1589994965851-a8f479c573a9"),
  "pegaso::Scienze della Formazione Primaria (LM-85 bis) · Ciclo Unico 5 anni": u("photo-1503676260728-1c00da094a0b"),
  "pegaso::Scienze Economiche (LM-56)": u("photo-1551288049-bebda4e38f71"),
  "pegaso::Management dello Sport (LM-47)": u("photo-1517649763962-0c623066013b"),
  "pegaso::Psicologia (LM-51)": u("photo-1507003211169-0a1dd7228f2d"),
  "pegaso::Ingegneria Civile (LM-23)": u("photo-1581094288338-2314dddb7ece"),
  "pegaso::Scienze Pedagogiche (LM-85)": u("photo-1577896851231-70ef18881754"),
  "pegaso::Master in Criminologia": u("photo-1453873531674-2151bcd01707"),
  "pegaso::Master in Digital Marketing": u("photo-1460925895917-afdab827c52f"),
  "pegaso::Master in HR Management": u("photo-1521737604893-d14cc237f11d"),
  "pegaso::Master in Nutrizione e Dietologia": u("photo-1490645935967-10de6ba17061"),
  "pegaso::Master in Diritto del Lavoro": u("photo-1450101499163-c8848c66ca85"),
  "pegaso::Master in Project Management": u("photo-1552664730-d307ca884978"),

  // ───── MERCATORUM ─────
  "mercatorum::Economia Aziendale (L-18)": u("photo-1556761175-5973dc0f32e7"),
  "mercatorum::Economia e Commercio (L-33)": u("photo-1559526324-4b87b5e36e44"),
  "mercatorum::Gestione d'Impresa (L-18)": u("photo-1521791136064-7986c2920216"),
  "mercatorum::Scienze dell'Educazione (L-19)": u("photo-1588072432836-e10032774350"),
  "mercatorum::Ingegneria Informatica (L-8)": u("photo-1555066931-4365d14bab8c"),
  "mercatorum::Scienze Politiche (L-36)": u("photo-1555848962-6e79363ec58f"),
  "mercatorum::Giurisprudenza (LMG/01) · Ciclo Unico 5 anni": u("photo-1505664194779-8beaceb93744"),
  "mercatorum::Management (LM-77)": u("photo-1542744173-8e7e53415bb0"),
  "mercatorum::Scienze Pedagogiche (LM-85)": u("photo-1509062522246-3755977927d7"),
  "mercatorum::Innovazione e Imprenditorialità (LM-77)": u("photo-1559136555-9303baea8ebd"),
  "mercatorum::Master in Business Administration (MBA)": u("photo-1573164713988-8665fc963095"),
  "mercatorum::Master Legale d'Impresa": u("photo-1521587760476-6c12a4b040da"),
  "mercatorum::Master Coordinamento Pedagogico": u("photo-1580582932707-520aed937b7b"),
  "mercatorum::Master in Food & Beverage Management": u("photo-1414235077428-338989a2e8c0"),

  // ───── SAN RAFFAELE ─────
  "sanraffaele::Scienze Motorie (L-22)": u("photo-1571019613454-1cb2f99b2d8b"),
  "sanraffaele::Scienze della Nutrizione (L-29)": u("photo-1512621776951-a57141f2eefd"),
  "sanraffaele::Psicologia (L-24)": u("photo-1494790108377-be9c29b29330"),
  "sanraffaele::Scienze Infermieristiche (L/SNT1)": u("photo-1576091160550-2173dba999ef"),
  "sanraffaele::Scienze Politiche (L-36)": u("photo-1529107386315-e1a2ed48a620"),
  "sanraffaele::Psicologia Clinica (LM-51)": u("photo-1551836022-deb4988cc6c0"),
  "sanraffaele::Scienze della Nutrizione Umana (LM-61)": u("photo-1498837167922-ddd27525d352"),
  "sanraffaele::Scienze Motorie (LM-67)": u("photo-1581009146145-b5ef050c2e1e"),
  "sanraffaele::Master in Naturopatia": u("photo-1545205597-3d9d02c29597"),
  "sanraffaele::Master in Criminologia Clinica": u("photo-1591115765373-5207764f72e7"),
  "sanraffaele::Master in Scienze Olistiche": u("photo-1518495973542-4542c06a5843"),
  "sanraffaele::Master in Nutrizione Sportiva": u("photo-1546069901-ba9599a7e63c"),
  "sanraffaele::Master in Coaching e Counseling": u("photo-1573497019418-b400bb3ab074"),
};

const FALLBACK = u("photo-1523240795612-9a054b0db644");

export function getCourseImage(uniId, name) {
  return MAP[`${uniId}::${name}`] || FALLBACK;
}
